<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/settlement/history')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateSubmit">
              <div class="mb-10 text-left">
                <div class="mb-5">Branch</div>
                <b-form-select :disabled="branch_id != null" name="branch" v-model="branch_id" @change="changeBranch">
                  <option :value="null">Please select</option>
                  <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Total Price</div>
                <b-form-input v-model="editData.total_amount" name="price" v-validate="'required|numeric'" type="text"></b-form-input>
                <span class="error">{{ errors.first('price') }}</span>
              </div>
              <div class="mb-20 text-left">
                <div class="mb-5">Receipt</div>
                <b-form-file name="receipt_image" v-validate="'required'" @change="previewImage" accept="image/*" v-model="editData.receipt" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                <div class="image-preview" v-if="imageData.length > 0">
                    <img class="preview" :src="imageData">
                </div>
                <span class="error">{{ errors.first('receipt_image') }}</span>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Payment Type</div>
                <b-form-select name="payment_type" disabled v-validate="'required'" v-model="editData.payment_type" :options="options" class="bg-transparent" />
                <span class="error">{{ errors.first('payment_type') }}</span>
              </div>
              <div class="mb-10 text-left">
                <div class="mb-5">Payment Type</div>
                <b-form-select v-validate="'required'" name="customer_service" v-model="editData.customer_service_id" class="form-control">
                  <option :value="null" selected>Please select</option>
                  <option v-for="item in itemsCs" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
                <span class="error">{{ errors.first('customer_service') }}</span>
              </div>
              <!-- {{editData.receipt_date}} -->
              <div class="text-right">
                <button class="btn-primary pt-5 pb-5">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'editSlideBanner',
  data: function () {
    return {
      dataBranch: [],
      loadingActive: false,
      branch_id: null,
      itemsCs: [],
      editData: {
        customer_service_id: null,
        receipt_date: '',
        total_amount: '',
        receipt: '',
        payment_type: ''
      },
      imageData: '',
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'BCA', text: 'BCA' },
        { value: 'CIMB', text: 'CIMB' },
        { value: 'CASH', text: 'CASH' }
      ]
    }
  },
  methods: {
    validateSubmit () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          data.append('receipt_date', this.editData.receipt_date)
          data.append('total_amount', this.editData.total_amount)
          data.append('receipt', this.editData.receipt)
          data.append('payment_type', this.editData.payment_type)
          data.append('branch_id', this.branch_id)
          data.append('customer_service_id', this.editData.customer_service_id)
          axios.put('crm/v1/settlement/' + this.$route.query.id, data).then(response => {
            // console.log('test', response)
            this.$router.push('/settlement/history')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.get('crm/v1/settlement/' + this.$route.query.id).then(response => {
        // console.log('test', response)
        this.editData = response.data.data
        this.imageData = response.data.data.image_receipt
        this.branch_id = response.data.data.branch_id
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service').then(response => {
        // console.log(response.data.data.rows)
        this.itemsCs = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
